import { type CartePrimaireTableauDeBordÉlèveProps } from "./CartePrimaireTableauDeBordÉlève.interface";
import LienInterne from "@/components/Lien/LienInterne/LienInterne";

const CartePrimaireTableauDeBordÉlève = ({
  titre,
  sousTitre,
  illustration,
  lien,
  vertical,
}: CartePrimaireTableauDeBordÉlèveProps) => {
  return (
    <div className="fr-enlarge-link grid h-full grid-rows-[1fr_auto] content-evenly border border-b-4 border-solid border-[--border-default-grey] border-b-[--border-action-high-blue-france] bg-white p-8 md:px-10 md:pt-10">
      <div
        className={`grid grid-flow-row text-center lg:text-left ${vertical ? "" : "justify-items-center gap-6 lg:grid-flow-col"}`}
      >
        {illustration && (
          <img
            alt=""
            className={vertical ? "w-[124px]" : "w-[88px]"}
            src={illustration}
          />
        )}
        <div className={vertical ? "" : "pt-2"}>
          <LienInterne
            ariaLabel={titre}
            href={lien}
            variante="neutre"
          >
            <h2 className="fr-h3 mb-2 text-[--text-active-blue-france]">{titre}</h2>
          </LienInterne>
          <p
            className="fr-text fr-text--lg mb-0 text-[--text-default-grey]"
            style={{ whiteSpace: "pre-line" }}
          >
            {sousTitre}
          </p>
        </div>
      </div>
      <div className="text-right">
        <i className="fr-icon-arrow-right-line text-[--text-active-blue-france]" />
      </div>
    </div>
  );
};

export default CartePrimaireTableauDeBordÉlève;
